var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { rules: _vm.rules, model: _vm.form, "label-width": "80px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "姓名", prop: "name" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "說明", prop: "description" } },
            [
              _c("el-input", {
                attrs: { type: "textarea" },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "email", prop: "email" } },
            [
              _c("el-input", {
                attrs: { placeholder: "(email為登入帳號)", type: "email" },
                model: {
                  value: _vm.form.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "text-left", attrs: { label: "角色" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "選擇角色" },
                  model: {
                    value: _vm.form.role_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "role_id", $$v)
                    },
                    expression: "form.role_id",
                  },
                },
                _vm._l(_vm.roles, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.roleLabel !== "0"
            ? _c(
                "el-form-item",
                { staticClass: "text-left", attrs: { label: "經銷商" } },
                [
                  _c("selectCompany", {
                    attrs: { id: _vm.form.company_id },
                    on: {
                      "update:id": function ($event) {
                        return _vm.$set(_vm.form, "company_id", $event)
                      },
                      onSelect: _vm.onSelectCompany,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "密碼", prop: _vm.password } },
            [
              _c("el-input", {
                attrs: { type: "password" },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", _vm._n($$v))
                  },
                  expression: "form.password",
                },
              }),
            ],
            1
          ),
          _vm.form.password
            ? _c(
                "el-form-item",
                { attrs: { label: "密碼確認", prop: _vm.passwordCheck } },
                [
                  _c("el-input", {
                    attrs: { type: "password" },
                    model: {
                      value: _vm.form.passwordCheck,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "passwordCheck", _vm._n($$v))
                      },
                      expression: "form.passwordCheck",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit()
                    },
                  },
                },
                [_vm._v(_vm._s(this.user ? "存檔" : "建立"))]
              ),
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }